document.addEventListener("DOMContentLoaded", () => {
  //动态给所有的h1/h2/h3加上id
  const headings = document.querySelectorAll("h1, h2, h3");
  const usedIds = new Set(); // 防止重复 id

  headings.forEach((heading) => {
    if (heading.id) return; // 已有 id 则跳过
    let text = heading.textContent || heading.innerText || "";
    let id = text;

    // 如果 id 为空（比如只有标点），生成 fallback
    if (!id) {
      id = "section-" + Array.from(usedIds).length;
    }

    // 防止重复：如果已存在，加后缀
    let finalId = id;
    let counter = 1;
    while (usedIds.has(finalId)) {
      finalId = id + "-" + counter;
      counter++;
    }

    usedIds.add(finalId);
    heading.id = finalId;
  });

  const tableTitles = document.querySelectorAll(".table-of-contents ul li");
  const tempArticleTitles = document.querySelectorAll(`h1[id], h2[id], h3[id]`);
  const articleTitles = Array.from(tempArticleTitles).concat(
    Array.from(document.querySelectorAll(".article-paragraph-title")),
  );

  const tablemenu = document.querySelector(".table-of-contents");

  var headerheight = document
    .querySelector("header.header")
    .getBoundingClientRect().height;
  var footer = document.querySelector("footer.footer");

  var rollState = true;

  tableTitles.forEach((title, index) => {
    title.addEventListener("click", () => {
      tableTitles.forEach((title) => {
        title.classList.remove("title-scroll-active");
      });

      title.classList.add("title-scroll-active");

      rollState = false;

      setTimeout(function () {
        rollState = true;
      }, 1000);
    });

    if (index === 0) {
      title.classList.add("title-scroll-active");
    }

    // 给菜单标题插入 data-targe
    var dataTarge = title
      .querySelector("a")
      .getAttribute("href")
      .replace("#", "");
    title.setAttribute("data-target", dataTarge);
  });

  window.addEventListener("scroll", () => {
    if (rollState && window.innerWidth > 1000) {
      articleTitles.forEach((module) => {
        const rect = module.getBoundingClientRect();
        const targetTitle = document.querySelector(
          `[data-target="${module.id}"]`,
        );
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          if (targetTitle) {
            tableTitles.forEach((title) => {
              title.classList.remove("title-scroll-active");
            });

            targetTitle.classList.add("title-scroll-active");
          }
        }
      });
    }
    var scrollTop =
      window.pageYOffset - headerheight ||
      document.documentElement.scrollTop - headerheight;
    var footertop =
      footer.offsetTop -
      tablemenu.getBoundingClientRect().height -
      headerheight * 2;

    if (scrollTop > footertop) {
      tablemenu.style.top = footertop + "px";
    } else {
      tablemenu.style.top = scrollTop + headerheight + 20 + "px";
    }
  });

  tablemenu.style.top = headerheight / 2 + 20 + "px";
});
